import { IModuleInitializerParams } from "@/Common/Modularity/ModuleInitializer";
import { ModuleInitializerBuilder } from "@/Common/Modularity/ModuleInitializerBuilder";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { ModuleNames } from "../ModuleNames";

function isFeatureFlagEnabled(params: IModuleInitializerParams): boolean {
    return params.clinicSettings.EnableOntarioLaboratoryInformationSystem;
}

function isActiveSiteOntario(params: IModuleInitializerParams): boolean {
    return params.currentEmployee.getActiveSite().isSiteInProvince(CanadaState.Ontario);
}

function userHasAcceptedLicence(params: IModuleInitializerParams): boolean {
    const acceptedLicenceCode = ["CMO", "OCP", "CNO", "RDCSO", "CPSO"];
    const organizationId = params.currentEmployee.Model.Licences[0].IssuingLicenseOrganizationRuleId;
    if (!organizationId)
        return false;

    const organization = params.allLicenseOrganizationRulesById[organizationId];
    return acceptedLicenceCode.includes(organization?.OrganisationCode);
}

function shouldLoadOlisModule(params: IModuleInitializerParams): boolean {
    return isFeatureFlagEnabled(params) && isActiveSiteOntario(params) && userHasAcceptedLicence(params);
}

const initializeOlis = new ModuleInitializerBuilder()
    .withConditionalLoading(shouldLoadOlisModule)
    .build(ModuleNames.Olis, async () => (await import("./OlisModule")).default);

export default initializeOlis;
